import { FieldType, FieldValue, FilterField, Filters, O } from "../../../../features/ui"
import { useEffect, useState } from "react"
import { DataType } from "../../../../tables"
import { Category } from "../../state/types"
import { useCategoryHooks } from "../../hooks/categoryHooks"

type Props = {
    categories: Category[]
    onSearchStart: () => void
    onSearchDone: (dataTypes: DataType[]) => void
}

const FiltersKey = 'category'

export const CategoryFilters = (props: Props) => {
    const { categories, onSearchStart, onSearchDone } = props
    const [searchText, setSearchText] = useState<string>()
    const { searchCategories } = useCategoryHooks()

    useEffect(() => search(searchText), [categories])

    const search = (searchTextParam?: string) => {
        onSearchStart()
        searchCategories(categories, searchTextParam).then(searchedList => {
            setTimeout(() => onSearchDone(searchedList as DataType[]), 100)
        })
    }

    const handleSearch = (value?: FieldValue) => {
        const newSearchText = value as O<string>
        setSearchText(newSearchText)
        search(newSearchText)
    }

    const searchField: FilterField = {
        name: 'search',
        type: FieldType.TEXT,
        placeholder: 'Buscar categoría...',
        icon: 'search',
        onChange: handleSearch
    }

    return (
        <Filters
            filtersKey={FiltersKey}
            searchField={searchField}
        />
    )
}